import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContactAndAddressService } from '@services/contact-and-address/contact-and-address.service';
import { TranslateService } from '@services/translate/translate.service';
import { Models } from '@ibexfusion/models';
import { MessengerService } from '@services/messenger/messenger.service';

@Component({
    selector: 'edit-contact-dialog',
    templateUrl: './edit-contact-dialog.component.html',
    styleUrls: ['./edit-contact-dialog.component.scss'],
    providers: [ContactAndAddressService],
    standalone: false
})
export class EditContactDialogComponent implements OnInit {

  element: Models.AddressAssetModel;
  contactTranslation: any;
  errorMessage;

  constructor(
    public dialogRef: MatDialogRef<EditContactDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public contactAndAddressService: ContactAndAddressService,
    private ts: TranslateService, private ms: MessengerService
  ) {
  }

  async ngOnInit() {
    this.contactTranslation = this.ts.get('contact');
    this.element = new Models.AddressAssetModel();
    if (this.data.element) {
      this.element.coordinates = {
        latitude: '',
        longitude: ''
      }
      this.element = Object.assign(this.element, this.data.element);
    } else {
      if (this.data.type === 'contact') {
        if (this.data?.content?.content?.contact?.length) {
          for (const element of this.data.content.content.contact) {
            this.element[element.type] = element.value;
          }
        }
        if (this.data?.content?.content?.website) {
          this.element.website = this.data.content.content.website;
        }
      } else {
        this.element.coordinates = {};
        if (this.data?.content?.content?.location) {
          this.element.street = this.data.content.content.location.address;
          this.element.zip = this.data.content.content.location.zip;
          this.element.city = this.data.content.content.location.city;
          this.element.coordinates = this.data.content.content.location.coordinates;
        }
      }
    }
  }

  async save() {
    if (!this.element.title || (this.data.type === 'contact' && !this.element.email && !this.element.fax && !this.element.phone && !this.element.website) ||
      (this.data.type === 'address' && !this.element.street && !this.element.zip && !this.element.city && !this.element.coordinates.latitude && !this.element.coordinates.longitude)
    ) {
      return this.errorMessage = this.contactTranslation.errors.emptyFields;
    }
    if (this.data.element) {
      await this.contactAndAddressService.update(this.element._id, this.element);
      return this.dialogRef.close(true);
    }
    this.element.OwnerOrganisationID = this.ms.getOrganisation().OrganisationID as any;
    this.element.type = this.data.type;
    if (Object.keys(this.element?.coordinates).length) {
      if (!this.element.coordinates.latitude || !this.element.coordinates.longitude) {
        this.element.coordinates = {};
      }
    }
    const res = await this.contactAndAddressService.create(this.element);
    this.dialogRef.close(res);
  }

  get checkFields() {
    return !this.element.title || (this.data.type === 'contact' && !this.element.email && !this.element.fax && !this.element.phone && !this.element.website) ||
      (this.data.type === 'address' && !this.element.street && !this.element.zip && !this.element.city &&
        !this.element.coordinates.latitude && !this.element.coordinates.longitude);
  }
}
